const FieldSet = ({
    children,
    legend,
    classNames: { fieldsetClassName, legendClassName },
    styles: { legendStyle, fieldsetStyle }
}) => {
    return (
        <fieldset className={fieldsetClassName} style={fieldsetStyle}>
            <legend style={legendStyle} className={legendClassName}>
                {legend}
            </legend>
            {children}
        </fieldset>
    );
};

export default FieldSet;
